document.addEventListener('click', function(e){
  const openBtn = e.target.closest('[data-sizechart-open]');
  const closeBtn = e.target.closest('[data-sizechart-close]');
  const modal = document.querySelector('[data-sizechart-modal]');

  if (openBtn && modal) {
    modal.hidden = false;
    document.documentElement.classList.add('sizechart-open');
  }

  if (closeBtn && modal) {
    modal.hidden = true;
    document.documentElement.classList.remove('sizechart-open');
  }
});

document.addEventListener('keydown', function(e){
  if (e.key !== 'Escape') return;
  const modal = document.querySelector('[data-sizechart-modal]');
  if (modal && !modal.hidden) {
    modal.hidden = true;
    document.documentElement.classList.remove('sizechart-open');
  }
});
